module.exports = __webpack_public_path__ + "static/media/1-0.ba9bbd05.png";